import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "./TenantChangeDetailModal.module.css";
import {IAM_SERVER_AUTH_TOKEN_POLICY, IAM_SERVER_PROFILES, IAM_SERVER_SERVICE, IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import Loading from "../../../utils/loading/Loading";

// ✅ 기본 프로필 이미지 URL (fallback)
const DEFAULT_PROFILE_IMG = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const TenantChangeDetailModal = ({data, update}) => {

    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [loading, setLoading] = useState(true);
 
    const [oldOwnerProfile, setOldOwnerProfile] = useState(null);
    const [newOwnerProfile, setNewOwnerProfile] = useState(null);

    const [transferData, setTransferData] = useState(data);


    const [formData, setFormData] = useState({
        tenantId: '',
        tenantName: '',
        detail: '',
        businessName: '',
        businessNumber: '',
        createdBy: '',
        createdByName: '',
    });

    const fetchData = async () => {
        try {


            const oldOwnerTenant = await axios.get(`${IAM_SERVER_TENANT_USER}/get/${transferData.oldOwnerTenantUserId}`);
            const oldOwner = await axios.get(`${IAM_SERVER_PROFILES}/get/${oldOwnerTenant.data.data.profileId}`);
            setOldOwnerProfile(oldOwner.data.data);

            const newOwnerTenant = await axios.get(`${IAM_SERVER_TENANT_USER}/get/${transferData.newOwnerTenantUserId}`);
            const newOwner = await axios.get(`${IAM_SERVER_PROFILES}/get/${newOwnerTenant.data.data.profileId}`);
            setNewOwnerProfile(newOwner.data.data);

            setLoading(false);
        } catch (error) {

            showDialog(DialogEnum.DEFAULT, "실패", "데이터 불러오기 실패");
        }
    };

    useEffect(() => {
       fetchData();
    }, []);

    // 테넌트 소유주 변경 승인
    const handleApproval = () => {
        const url = IAM_SERVER_TENANT + "/updateOwnerTransfer";
        const params = {
            ...transferData,
            status: 'approval'
        };

        axios.post(url, params)
            .then((res) => {
            showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
            update();
            })
            .catch((e) => {
            showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });


    };

    // 테넌트 소유주 변경 거절
    const handleReject = () => {
        const url = IAM_SERVER_TENANT + "/updateOwnerTransfer";
        const params = {
            ...transferData,
            status: 'reject'
        };

        axios.post(url, params)
            .then((res) => {
            showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
            update();
            })
            .catch((e) => {
            showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    const transStatusView = (status) => {
        switch (status) {
        case 'approval':
            return <span className={styles.badge} style={{ backgroundColor: '#4CAF50' }}>승인</span>;
        case 'reject':
            return <span className={styles.badge} style={{ backgroundColor: '#F44336' }}>거절</span>;
        default:
            return <span className={styles.badge} style={{ backgroundColor: '#F44336' }}>변경대기</span>;
        }
    };

    if (loading) {
        return <Loading />; // 로딩 중 표시
    }

    // ✅ 버튼 활성화/비활성화 조건
    const isPending = transferData.status === 'pending';

    return (
        <div style={{overflow: "auto"}}>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>테넌트 명</p>
                    <input className={styles.layer__listInput} type={"text"} value={transferData.tenantName} readOnly={true} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>요청 상태</p>
                    {/* {transStatusView(data.status)} */}
                    <input className={styles.layer__listInput} type={"text"} value={data.status === 'pending' ? '변경대기' : '거절'} readOnly={true} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>요청일</p>
                    <input className={styles.layer__listInput} type={"text"} value={transferData.createdDateView} readOnly={true} />
                </li>
            </ul>

            <h3 className={styles.sectionTitle} style={{marginTop: "30px"}}>소유주 변경 정보</h3>
            <div className={styles.ownerTransferSection}> {/* ✅ 새로운 섹션 추가 */}
                <div className={styles.ownerInfoCard}>
                    <h4>기존 소유주</h4>
                    <div className={styles.profileBox}>
                        <img 
                            src={oldOwnerProfile?.profileImgUrl || DEFAULT_PROFILE_IMG} 
                            alt="기존 소유주 프로필" 
                            className={styles.profileImg} 
                        />
                        <p className={styles.profileName}>{oldOwnerProfile?.profileName || '알 수 없음'}</p>
                        <p className={styles.profileEmail}>{transferData.oldOwnerUnifiedProfileId}</p>
                    </div>
                </div>

                <div className={styles.transferArrow}>
                    <span className="material-symbols-outlined">arrow_right_alt</span> {/* 폰트 어썸 아이콘 사용 시 `fa-arrow-right` 등 */}
                </div>

                <div className={styles.ownerInfoCard}>
                    <h4>새로운 소유주</h4>
                    <div className={styles.profileBox}>
                        <img 
                            src={newOwnerProfile?.profileImgUrl || DEFAULT_PROFILE_IMG} 
                            alt="새로운 소유주 프로필" 
                            className={styles.profileImg} 
                        />
                        <p className={styles.profileName}>{newOwnerProfile?.profileName || '알 수 없음'}</p>
                        <p className={styles.profileEmail}>{transferData.newOwnerUnifiedProfileId}</p>
                    </div>
                </div>
            </div>

            <div className={styles.layer__sensorBtnBox}>
                <button 
                    className={styles.layer__cancleBtn} 
                    onClick={handleReject} 
                    disabled={!isPending} // pending 상태일 때만 활성화
                >
                    거절
                </button>
                <button 
                    className={styles.layer__modifyBtn} 
                    onClick={handleApproval} 
                    disabled={!isPending} // pending 상태일 때만 활성화
                >
                    승인
                </button>                        
            </div>

        </div>
    );
}
